export default __webpack_public_path__ + "static/media/studymate.d942b72b.jpg";